import React from "react";

// Route
import { useNavigate } from "react-router-dom";

// Icons
import { MdBubbleChart } from "react-icons/md";
import { HiCloud } from "react-icons/hi";
import { FaCircle } from "react-icons/fa";
import { HomeOutlined } from "@ant-design/icons";

// Components
import { Button } from "antd";

// CSS
import "./style/_error.scss";

// Images
import AccessDenied from "./images/accessdenied.svg";
import PageNotFound from "./images/pagenotfound.svg";
import InternalServerError from "./images/internalservererror.svg";
import Error from "./images/error.svg";
import Maintenance from "./images/maintenance.svg";

const details = {
    403: {
        title: "403",
        subtitle: "Access Denied",
        description: "You don't have permissions to access this page.",
        image: AccessDenied
    },
    404: {
        title: "404",
        subtitle: "Page Not Found",
        description: "The page you're looking for doesn't exist.",
        image: PageNotFound
    },
    500: {
        title: "500",
        subtitle: "Internal Server Error",
        description:
      "The server has been deserted for a while. Please try again later.",
        image: InternalServerError
    },
    maintenance: {
        title: "Server Maintenance",
        subtitle: "We sincerely apologize for the inconvenience",
        description:
      "Our site currently under maintenance and will return shortly.",
        image: Maintenance
    },
    error: {
        title: "Oops!",
        subtitle: "Something went wrong",
        description:
      "We are working on fixing the problem. Please try again later.",
        image: Error
    }
};

const ErrorPage = function ({
    type = "error",
    title,
    subTitle,
    description,
    image,
    url,
    path,
    extra,
    hideDefaultContent,
    hideDefaultExtra
}) {
    const navigate = useNavigate();

    function DefaultContent(props) {
        return (
            <>
                <p
                    className="custom-error-content-title"
                    style={{
                        fontSize: type === "maintenance" ? "5.5rem" : "8rem"
                    }}
                >
                    {title || (details[type]
                        ? details[type].title
                        : details.error.title)}
                </p>
                <p
                    className="custom-error-content-subtitle"
                    style={{
                        fontSize: type === "maintenance" ? "2.3rem" : "3rem",
                        marginTop: type === "maintenance" ? "2mm" : "0mm"
                    }}
                >
                    {subTitle || (details[type]
                        ? details[type].subtitle
                        : details.error.subtitle)}
                </p>
                <p className="custom-error-content-description">
                    {description || (details[type]
                        ? details[type].description
                        : details.error.description)}
                </p>
            </>
        );
    }

    function DefaultExtra(props) {
        const helpcenterUrl = "https://knowledge.sqreemtech.com/";
        return (
            <>
                <Button
                    className="custom-error-content-back"
                    onClick={() => {
                        if (url) {
                            window.location.href = url;
                        } else {
                            navigate(path || "/");
                        }
                    }}
                >
                    <HomeOutlined />
                    Back to Home
                </Button>
                <a
                    className="custom-error-content-reload"
                    onClick={() => {
                        window.location.reload();
                    }}
                >
                    Reload Page
                </a>
                <a
                    className="custom-error-content-help"
                    onClick={() => {
                        window.open(helpcenterUrl, "_blank");
                    }}
                >
                    Visit our Help Center
                </a>
            </>
        );
    }

    function Image(props) {
        return (
            <img
                src={
                    image || (details[type]
                        ? details[type].image
                        : details.error.image)
                }
                className="custom-error-content-image"
                alt="errorpage"
            />
        );
    }

    return (
        <div className="custom-error">
            <div className="custom-error-content">
                <MdBubbleChart className="bg-image-bubble" />
                {!hideDefaultContent && <DefaultContent />}
                {!hideDefaultExtra && <DefaultExtra />}
                {extra || <></>}
            </div>
            <div className="bg-image-cloud">
                <HiCloud />
            </div>
            <Image />
            <div className="bg-image-circle-bottom bg-circle">
                <FaCircle />
            </div>
            <div className="bg-image-circle-top bg-circle">
                <FaCircle />
            </div>
        </div>
    );
};
export default ErrorPage;
